var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c(_vm.layout,{tag:"component"},[_c('v-main',{class:`${
        _vm.checkSetting ? 'auth-setting' : _vm.checkAuthLayout ? 'auth-main' : ''
      }`},[_c('router-view')],1)],1),_c('Alert')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }